import { useCallback } from 'react';

import { ShortUrl } from '@air/api';
import { useShortIdContext } from '@air/provider-short-id';

import { type GetBaseMetadata, type ZippingTask } from '~/store/tasks/types';
import { useCreateTask } from '~/utils/taskUtils/useCreateTask';

export type CreatePublicZippingTaskParams = GetBaseMetadata<ZippingTask>;

export const useCreatePublicZippingTask = () => {
  const { createTask } = useCreateTask();
  const { shortId } = useShortIdContext();

  const createPublicZippingTask = useCallback(
    async ({ boardIds = [], clipIds = [], collectionIds = [] }: CreatePublicZippingTaskParams) => {
      return createTask({
        task: {
          type: 'ZippingForDownload',
          shortId,
          metadata: {
            boardIds,
            clipIds,
            collectionIds,
            secondsRemaining: undefined,
          },
        },
        createTask: () => {
          return ShortUrl.Tasks.createTask(shortId, {
            type: 'ContentExporter',
            args: {
              boardIds,
              clipIds,
              collectionIds,
            },
          });
        },
      });
    },
    [createTask, shortId],
  );

  return {
    createPublicZippingTask,
  };
};
